export default "__VITE_ASSET__BfntCyS3__"